import React, { useEffect, useState } from 'react'
import Footer from '../../components/Footer'
import NavBarNotificationBar from '../AppAdminComponents/NavBarNotificationBar'
import AsideLeftMenuBills from './AsideLeftMenuBills'
import { getAll } from '../../services/bills.service';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import formatDate from '../../helpers/date.helper';
import formatMoney from '../../helpers/money.helper';

export default function BillsToReceive() {
    const [billsData, setbillsData] = useState([]);

    useEffect(() => {

        async function fetchData() {
            await fetchBillsToReceiveData();
        }

        fetchData();
    }, []);

    async function fetchBillsToReceiveData(sizeRows, page, isPaginate) {
        let bills = await getAll();
        setbillsData(bills?.data || []);
    }

    const formatLastDateCob = (row) => {
        const response = formatDate(row.last_billing_date);

        if(response === 'Invalid date') return '-';
        else return formatDate(row.last_billing_date);
    }

    const optionButtons = (rowData, column) => {
        return (
            <div>

                <button
                    onClick={() => console.log('rowData', rowData)}
                    title="Visualizar item"
                    type="button"
                    className="btn btn-icon btn-danger btn-sm"
                >
                    <i className="fa fa-search"></i>
                </button>
                &nbsp;
                <button
                    onClick={() => console.log('rowData', rowData)}
                    title="Visualizar item"
                    type="button"
                    className="btn btn-icon btn-info btn-sm"
                >
                    <i className="fa fa-search"></i>
                </button>
                &nbsp;
                <button
                    onClick={() => console.log('rowData', rowData)}
                    title="Visualizar item"
                    type="button"
                    className="btn btn-icon btn-info btn-sm"
                >
                    <i className="fa fa-search"></i>
                </button>

            </div>
        );
    };

    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />
                </nav>
                <AsideLeftMenuBills />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Contas pendentes</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <DataTable
                                    value={billsData}
                                    style={{ marginBottom: 50 }}
                                    paginator
                                    rows={40}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    className="p-datatable-customers"
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                                    emptyMessage="Nnehuma conta encontrada"
                                >
                                    <Column field="id" header="Código" />

                                    <Column field="nome_cliente" header="Cliente" />
                                    <Column field="cod_pedido" header="Pedido" />
                                    <Column
                                        field="cod_cliente"
                                        header="Cod. Cliente"
                                        filter={true}
                                    />
                                    <Column
                                        field={(row) => formatMoney(row.valor)}
                                        header="Valor"
                                    />
                                    <Column
                                        field={(row) => formatDate(row.vencimento)}
                                        header="Vencimento"
                                    />
                                    <Column
                                        field={(row) => formatLastDateCob(row)}
                                        header="Data da ultima cobrança"
                                    />

                                    <Column
                                        key="123"
                                        body={optionButtons}
                                        bodyStyle={{
                                            textAlign: "center",
                                            overflow: "hidden",
                                        }}
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer local_version="1.0.0" />
            </div>
        </>
    )
}
